import { render, staticRenderFns } from "./WFAddFull.vue?vue&type=template&id=03a7f196"
import script from "./WFAddFull.vue?vue&type=script&lang=js"
export * from "./WFAddFull.vue?vue&type=script&lang=js"
import style0 from "./WFAddFull.vue?vue&type=style&index=0&id=03a7f196&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports